import {authHeader, handleResponsePublic as handleResponse} from '../_helpers';

export const orderService = {
  register,
  getAll,
  getByUser,
  getById,
  update,
  delete: _delete
};

function getAll(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/order${api_params}`, requestOptions).then(handleResponse);
}

function getByUser($page, $user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/order/?1=1&page=${$page}&user_id=${$user_id}`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/order/${id}`, requestOptions).then(handleResponse);
}

function register(order) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(order)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/order`, requestOptions).then(handleResponse);
}

function update(order) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(order)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/order/${order.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    cache: 'no-store',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}/topic/${id}`, requestOptions).then(handleResponse);
}


